import { Css, useTestIds } from "@homebound/beam";
import camelCase from "lodash/camelCase";
import { ReactNode } from "react";
import { Card } from "src/components/Card";
import { Icon, IconKey } from "src/components/Icon";

type ImpactCardRow = {
  /** Doubles as the row's test id, i.e. "Total Added" is `<cardTitle>_totalAdded`. */
  label: string;
  value: ReactNode;
};

type ImpactCardProps = {
  icon: IconKey;
  /** The card's name, i.e. "Budget Impact". Also the prefix for every test id in the card. */
  title: string;
  /** The card's bottom line, shown big next to the title, i.e. "+5 items". */
  headline: ReactNode;
  rows: ImpactCardRow[];
};

/** One of the "Budget / Scope / Schedule Impact" cards: a title + headline row above a list of `label -> value` rows. */
export function ImpactCard(props: ImpactCardProps) {
  const { icon, title, headline, rows } = props;
  const tid = useTestIds(props, camelCase(title));

  return (
    <Card {...tid}>
      <div css={Css.df.fdc.gap2.$}>
        <div css={Css.df.aic.jcsb.gap1.bb.bcGray200.pb2.$}>
          <div css={Css.df.aic.gap1.$}>
            <span css={Css.df.aic.jcc.bgGray100.br12.p1.$}>
              <Icon icon={icon} inc={2.5} />
            </span>
            <span css={Css.mdSb.$}>{title}</span>
          </div>
          <span css={Css.mdSb.$} {...tid.headline}>
            {headline}
          </span>
        </div>
        <div css={Css.df.fdc.gap1.$}>
          {rows.map((row) => (
            <div key={row.label} css={Css.df.aic.jcsb.gap1.sm.$}>
              <span css={Css.smSb.$}>{row.label}</span>
              <span {...tid[camelCase(row.label)]}>{row.value}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
